export const contentData = {
  spanish:{
    links:[
      {name:'Home', url:'/home'},
      {name:'Servicios', url:'/services'},
      {name:'Tecnologías', url:'/technologies'},
      {name:'Nosotros', url:'/about'},
    ]
  }
}